(() => {
  const STORAGE_KEY = 'senfineco.savedVehicleVin.v1';
  class SenfinecoCartAttribute extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.input = this.querySelector('[data-sf-cart-attribute]');
      this.remember = this.querySelector('[data-sf-vin-remember]');
      this.clearButton = this.querySelector('[data-sf-vin-clear]');
      this.status = this.querySelector('[data-sf-vin-status]');
      this.saveTimer = null;
      if (!this.input) return;
      const savedVin = this.readSavedVin();
      if (savedVin) {
        if (this.remember) this.remember.checked = true;
        if (this.clearButton) this.clearButton.hidden = false;
        if (!this.input.value.trim()) {
          this.input.value = savedVin;
          this.updateCartAttribute(savedVin, 'loaded');
        }
      }
      this.input.addEventListener('input', () => {
        this.input.value = this.normalize(this.input.value);
        this.setStatus('saving');
        window.clearTimeout(this.saveTimer);
        this.saveTimer = window.setTimeout(() => this.updateCartAttribute(this.input.value.trim(), 'saved'), 450);
      });
      this.remember?.addEventListener('change', () => {
        const value = this.input.value.trim();
        if (this.remember.checked) {
          if (value) {
            this.writeSavedVin(value);
            if (this.clearButton) this.clearButton.hidden = false;
            this.setStatus('device');
          }
        } else {
          this.removeSavedVin();
          if (this.clearButton) this.clearButton.hidden = true;
          this.setStatus('removed');
        }
      });
      this.clearButton?.addEventListener('click', () => {
        this.removeSavedVin();
        if (this.remember) this.remember.checked = false;
        this.clearButton.hidden = true;
        this.setStatus('removed');
      });
    }
    normalize(value) { return value.toUpperCase().replace(/\s+/g, ' ').slice(0, 32); }
    cartUpdateUrl() { return window.routes?.cart_update_url || '/cart/update.js'; }
    async updateCartAttribute(value, successState) {
      const key = this.input.dataset.attributeKey || 'VIN';
      try {
        const response = await fetch(this.cartUpdateUrl(), {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [key]: value } })
        });
        if (!response.ok) throw new Error('Cart attribute update failed');
        if (this.remember?.checked) {
          if (value) {
            this.writeSavedVin(value);
            if (this.clearButton) this.clearButton.hidden = false;
          } else {
            this.removeSavedVin();
            if (this.clearButton) this.clearButton.hidden = true;
          }
        }
        this.setStatus(successState || 'saved');
      } catch (error) { this.setStatus('error'); }
    }
    setStatus(state) {
      if (!this.status) return;
      this.status.textContent = this.status.dataset[state] || '';
      this.status.dataset.state = state;
    }
    readSavedVin() { try { return window.localStorage.getItem(STORAGE_KEY) || ''; } catch (error) { return ''; } }
    writeSavedVin(value) { try { window.localStorage.setItem(STORAGE_KEY, value); } catch (error) {} }
    removeSavedVin() { try { window.localStorage.removeItem(STORAGE_KEY); } catch (error) {} }
  }
  if (!customElements.get('senfineco-cart-attribute')) customElements.define('senfineco-cart-attribute', SenfinecoCartAttribute);
})();
